import React from 'react';
import './App.css';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import PhotosPage from './components/PhotosPage';
import MagicWordsPage from './components/MagicWordsPage';

function App({ signOut, user }) {
  const isLocalDev = process.env.REACT_APP_LOCAL_DEV || false;

  return (
    <Router>
      <div className="App">
        <header>
          <div className="header-content">
            <div className="header-brand">
              <h1 className="site-title">Wedding Pix</h1>
              <span className="site-subtitle">Admin</span>
            </div>
            <nav className="main-nav">
              <NavLink
                to="/"
                end
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              >
                Photos
              </NavLink>
              <NavLink
                to="/magic-words"
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              >
                Magic Words
              </NavLink>
            </nav>
            <div className="header-actions">
              {isLocalDev && (
                <span className="dev-indicator">Dev Mode</span>
              )}
              {!isLocalDev && (
                <button onClick={signOut} className="sign-out-btn">Sign Out</button>
              )}
            </div>
          </div>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<PhotosPage />} />
            <Route path="/magic-words" element={<MagicWordsPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

// Conditionally wrap with authenticator based on environment
const isLocalDev = process.env.REACT_APP_LOCAL_DEV || false;
const AppComponent = isLocalDev ? App : withAuthenticator(App);

export default AppComponent;
